import React from 'react'
import PropTypes from 'prop-types'

import { Section, Row, Column, Rows } from '@/components/layout'
import { Text } from '@/components/common'

import styles from './BoxedInfo.module.scss'

const BoxedInfo = ({ boxes, sectionTitle }) => (
  <Section className={styles.howUsesNeat}>
    <Rows gap={0}>
      <Row center textCenter>
        <Text.H2 style={{ marginBottom: '30px' }}>{sectionTitle}</Text.H2>
      </Row>
      <Row center className={styles.blockContainer} textCenter>
        {boxes.map((box) => (
          <Column key={box.title} className={styles.neatUserBlock}>
            <div>
              <Text.H3>{box.title}</Text.H3>
              <p>{box.description}</p>
            </div>
          </Column>
        ))}
      </Row>
    </Rows>
  </Section>
)

BoxedInfo.propTypes = {
  boxes: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })),
  sectionTitle: PropTypes.string.isRequired,
}

export default BoxedInfo
